export function calcResizingCursors(lang, directon, rect, prevClient, rowRect, ev) {
    let width = rect.width;
    let height = rect.height;
    let position = { x: rect.x, y: rect.y };
    let changeInfo = {};






    if (lang == 'fa') {
        if (directon == 'ne') {


        }
        else if (directon == 'nw') {

        }
        else if (directon == 'sw') {


            // console.log(width, height, position, prevClient, ev.clientX)
        }
        else if (directon == 'se') {


        }

        else if (directon == 'top') {


        }
        else if (directon == 'bottom') {



        }
        else if (directon == 'left') {



        }
        else if (directon == 'right') {



        }


    }
    else {

        if (directon == 'sw') {

        }
        if (directon == 'se') {

        }
        if (directon == 'ne') {

        }
        if (directon == 'nw') {

        }
        if (directon == 'top') {


        }
        if (directon == 'bottom') {


        }
        if (directon == 'left') {


        }
        if (directon == 'right') {
            // console.log(rowRect)
            let calculatedWidth = Math.round(rowRect.width / 12);
            let clientXDifference = Math.round(ev.clientX - prevClient.clientX);
            let changeStep = Math.floor(clientXDifference / calculatedWidth);
            // console.log(changeStep, calculatedWidth, clientXDifference)
            changeInfo = { changeStep, calculatedWidth };
            // console.log(prevClient)

        }

    }
    // console.log('position in func', position)
    return { width, height, position, changeInfo }

}